import axios from "axios"
import humps from "humps"

const loadUserData = async () => {
  const authDataSerialized = await localStorage.getItem("@AuthData")
  if (authDataSerialized) {
    const _authData = JSON.parse(authDataSerialized)
    return _authData
  }
  return null
}

axios.defaults.baseURL = process.env.REACT_APP_API_URL
axios.interceptors.request.use(
  async (request) => {
    if (
      request.method === "post" ||
      request.method === "POST" ||
      request.method === "put" ||
      request.method === "PUT" ||
      request.method === "patch" ||
      request.method === "PATCH"
    ) {
      if (request.headers?.["Content-Type"] !== "multipart/form-data") {
        request.data = humps.decamelizeKeys(request.data)
      }
    }

    if (!request.headers) {
      request.headers = {} as any
    }

    const token = localStorage.getItem("token")
    if (token) {
      request.headers.Authorization = `Token ${token}`
    }

    return request
  },
  (error) => Promise.reject(error)
)

/**
 * Intercept response
 *
 * - Camelize keys of data received from backend
 */
axios.interceptors.response.use(
  (response) => {
    const contentType = response.headers["content-type"] || response.headers["Content-Type"]
    if (contentType && typeof contentType === "string" && contentType.match(/application\/json/g)) {
      response.data = humps.camelizeKeys(response.data)
    }

    if (!response.data) {
      response.data = []
    }

    return response
  },
  (error) => {
    if (error.response) {
      console.log("Error ", error)
      if (error.response.status === 401) {
        console.log("You are unauthenticated")
        localStorage.removeItem("token")
        window.location.href = "/login"
      }

      if (
        error.response.status === 503 &&
        window.location.pathname !== "/maintenance"
      ) {
        window.location.href = "/maintenance"
      }
    }

    return Promise.reject(error)
  }
)

export default axios
